import React, { useCallback } from 'react';
import SearchInput from './index';
import Localization from '../../config/localization';
import { useSearch } from '../../hooks/search';
import * as UtilApi from '../../api/util';

const CountySearch = React.forwardRef((props: any, ref) => {
  const getLabel = useCallback((place?: Utils.ICounty) => place && place.countyName || '', []);
  const { selectedData: selectedCounty, data: counties, onChange, formatData } = useSearch({
    ref,
    onChange: props.onChange,
    onUpdate: props.onUpdate,
    api: UtilApi.SearchCounties,
    getLabel
  });

  return (
    <SearchInput
      label={Localization.paymentReportCountySelectLabel}
      placeholder={Localization.paymentReportCountyPlaceholder}
      getLabel={getLabel}
      {...props}
      defaultOption={selectedCounty}
      places={counties}
      onUpdate={formatData}
      onChange={onChange}
      withValidation={false}
    />
  );
});

export default CountySearch;